// extracted by mini-css-extract-plugin
export default {"tabItem":"TimeSlotTabHeader-module__tabItem___X-V-4"};